// Source: https://docs.appian.com/suite/help/21.4/Chart_Color_Scheme.html

export const ocean = {
    lightest: "#77C2FE",
    light: "#249CFF",
    middle: "#1578CF",
    dark: "#0A579E",
    darkest: "#003870",
}
